import * as ActionTypes from './ActionTypes';
import IProfileType from './IProfileType';
import ProfileApi from './ProfileApi';

function loadProfileSuccess(result: IProfileType) {
    return { type: ActionTypes.LOAD_PROFILE_SUCCESS, result: result };
}

export function loadProfile() {
    return function (dispatch: any) {
        return ProfileApi.load().then((result: IProfileType) =>
            dispatch(loadProfileSuccess(result))
        );
    };
}

export function saveProfile(profile: IProfileType) {
    const words = profile.name.split(/\s+/);
    if (words.length === 1) {
        profile.firstname = words[0];
        profile.lastname = '';
    } else if (words.length >= 2) {
        profile.firstname = words.slice(0, -1).join(' ');
        profile.lastname = words[words.length - 1];
    }
    return function (dispatch: any) {
        return ProfileApi.update(profile);
    };
}

export function uploadProfileImage(image: any) {
    return function (dispatch: any) {
        return ProfileApi.uploadProfileImage(image);
    };
}
